import { c as _c } from "react/compiler-runtime";
import { numberConvert } from "@website/utils/number-convert";
export type AccommodationCardReservationInfoProperties = {
  guestsCount: number;
  nightCount: number;
};
export const AccommodationCardReservationInfo: React.FC<AccommodationCardReservationInfoProperties> = t0 => {
  const $ = _c(6);
  const {
    guestsCount,
    nightCount
  } = t0;
  const shouldShowFromPerNight = guestsCount > 0 && nightCount > 0;
  let t1;
  if ($[0] !== guestsCount || $[1] !== nightCount || $[2] !== shouldShowFromPerNight) {
    t1 = shouldShowFromPerNight ? `${numberConvert(guestsCount, {
      locale: "fa"
    })} نفر و ${numberConvert(nightCount, {
      locale: "fa"
    })} شب` : " \u0642\u06CC\u0645\u062A \u0627\u0632 \u0634\u0628\u06CC";
    $[0] = guestsCount;
    $[1] = nightCount;
    $[2] = shouldShowFromPerNight;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <><span className="text-on-surface-high-emphasis text-extra-caption whitespace-nowrap font-[400]">{t1}</span></>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};